<ng-container *ngIf="workplace$ | async as currentWorkplace">
  <!-- Top section always visible -->
  <div class="alligned-grid-header padded top-section" *transloco="let t" (click)="expanded$.next(!expanded$.value)">
    <!-- Organization name and type-->
    <div class="org-name">
      <i
        class="material-symbols-rounded"
        [ngClass]="{
          filled: currentWorkplace.uuid === (currentSelectedUuid$ | async)
        }"
      >
        other_houses
      </i>
      <div class="name-wrapper">
        <span class="title">{{ currentWorkplace.workplaceName }}</span>
        <span class="type" *ngIf="currentWorkplace.isPrimary">{{ t('header/primaryWorkplace') }}</span>
      </div>
    </div>

    <!-- Empty to keep consistent spacing -->
    <div></div>

    <!-- Children/Teachers count -->
    <div class="org-stats">
      <div class="stat">
        <i class="material-symbols-rounded">child_hat</i>
        <span>{{ currentWorkplace.childrenCount || '-' }}</span>
      </div>
      <div class="stat">
        <i class="material-symbols-rounded">person</i>
        <span>{{ currentWorkplace.teachersCount || '-' }}</span>
      </div>
    </div>

    <!-- Buy license button -->
    <div class="org-controls">
      <a [routerLink]="links.priceList()" class="btn btn-primary">{{ t('settings/buyLicense') }}</a>

      <!-- Expand arrow -->
      <i
        class="material-symbols-rounded expand-arrow"
        [ngClass]="{
          expanded: expanded$ | async
        }"
      >
        keyboard_arrow_up
      </i>
    </div>
  </div>

  <!-- Bottom expandable section -->
  <div
    class="expandable padded"
    [ngClass]="{
      'alligned-grid': expanded$ | async
    }"
    *transloco="let t"
  >
    <ng-container *ngFor="let license of workplaceLicenses$ | async; let first = first">
      <ng-container *ngIf="first">
        <div class="header first">{{ t('settings/dateRange') }}</div>
        <div class="header">{{ t('settings/product') }}</div>
        <div class="header">{{ t('settings/bought') }}</div>
        <!-- Blank to keep consistent columns -->
        <div class="header"></div>
      </ng-container>

      <div class="expanded-col first">
        {{ license.validFrom | date : 'dd.MM.yyyy' }}
        <ng-container *ngIf="license.validTo">
          &nbsp;- &nbsp;<span
            [ngClass]="{
              'expired-date': license.aboutToExpire || license.expired
            }"
            >{{ license.validTo | date : 'dd.MM.yyyy' }}</span
          >
        </ng-container>
        <ng-container *ngIf="!license.validTo">
          &nbsp;- &nbsp;
          <span>{{ t('shared/unlimited') }}</span>
        </ng-container>
      </div>
      <div class="expanded-col title">
        <span class="title">{{ license.licenseTitle }}</span>
        <span class="subtitle" *ngIf="license.hasTrial">{{ t('settings/licenseTrial') }}</span>
      </div>
      <div class="expanded-col count">
        <div class="stat">
          <i class="material-symbols-rounded" *ngIf="!license.pedagogIcon">child_hat</i>
          <i class="material-symbols-rounded" *ngIf="license.pedagogIcon">person</i>
          <span>{{ license.purchasedCount || '-' }}</span>
        </div>
      </div>
      <!-- Notices -->
      <div class="expanded-col last">
        <!-- About to expire -->
        <div class="license-notice" *ngIf="license.aboutToExpire">
          <i class="material-symbols-rounded">error</i>
          <span>{{ t('settings/licenseAboutToExpire') }}</span>
          <div class="dot"></div>
          <a [routerLink]="links.priceList()" class="marked">{{ t('settings/licenseExtend') }}</a>
        </div>
        <!-- Expired -->
        <div class="license-notice" *ngIf="license.expired">
          <i class="material-symbols-rounded">error</i>
          <span>{{ t('settings/licenseExpired') }}</span>
          <div class="dot"></div>
          <a [routerLink]="links.priceList()" class="marked">{{ t('settings/buy') }}</a>
        </div>
      </div>
    </ng-container>

    <!-- Empty -->
    <div class="no-licenses" *ngIf="(workplaceLicenses$ | async)?.length === 0">
      {{ t('settings/noLicenses') }}
    </div>
  </div>
</ng-container>
